import { useCanViewMonitoring } from "./useCanViewMonitoring";

/** Same role gate as monitoring navigation (Admin, Manager, Proxy). */
export function useCanEnrollInMonitoring(): boolean {
  return useCanViewMonitoring();
}
